import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Tab, Tabs } from '@mui/material';
import { getStateDisplayName } from '../../../store/utils/shipmentUtils';
import { selectAccessibleFacilities } from '../../../store/selectors/shipmentModuleSelectors';
import { navigateToFacility } from '../../../store/thunks/shipmentModuleThunks';

const ShipmentFacilityTabs = () => {
  const dispatch = useDispatch();
  const { activeFacility } = useSelector(({ shipmentModule }) => shipmentModule);

  const facilities = useSelector(selectAccessibleFacilities);

  if (facilities.length === 0) return null;

  const handleChange = (event, newValue) => {
    dispatch(navigateToFacility({ pharmacyId: newValue }));
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
      <Tabs
        value={activeFacility}
        onChange={handleChange}
        variant='scrollable'
        scrollButtons='auto'
        sx={{
          minHeight: 36,
          '& .MuiTab-root': {
            minHeight: 36,
            py: 0,
            px: 1.5,
            textTransform: 'none',
          },
        }}
      >
        <Tab label='All Facilities' value='all' />
        {facilities.map((f) => (
          <Tab
            key={f.fulfillingPharmacyId}
            label={f.state ? `${f.name} (${getStateDisplayName(f.state)})` : f.name}
            value={f.fulfillingPharmacyId}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default ShipmentFacilityTabs;
